import React from 'react';
import PropTypes from 'prop-types';
import {Dialog} from './dialog';
import copyToClipboard from '../copyToClipboard';
import {TwitterShareButton, EmailShareButton} from 'react-share';
import {authorizedRequest} from '../request';
import Button from './button';
import Input from './forms/input';

const makeFirstLetterUppercase = s => s.charAt(0).toUpperCase() + s.slice(1);

export default class ShareDialog extends React.Component {
    constructor() {
        super();

        this.state = {
            passwordText: '',
            showPermissionsSettings: false,
            visibility: 'public',
            shareResponse: {shortUrl: 'none'}
        };

        this.showPermissionsSettingsClick = this.showPermissionsSettingsClick.bind(this);
        this.passwordInputOnChange = this.passwordInputOnChange.bind(this);
        this.handleRadioClick = this.handleRadioClick.bind(this);
        this.updateShareWithPassword = this.updateShareWithPassword.bind(this);
    }

    componentDidMount() {

        const discPackageType = this.props.currentAsset ? this.props.currentAsset.model : '';
        if (discPackageType) {

            var pkgType = 'dvdchap';
            if(discPackageType == "imemops.DiscPackage"){
                if(this.props.currentAsset.discPackageType == "PhotoCdPackage"){
                    pkgType = "pcdpkg"
                }else{
                    pkgType = "dvdpkg"
                }
            }else if (discPackageType === 'imemops.PhotoCdSourcePhoto') {
                pkgType = 'pcdsp';
            }else{
                pkgType = "dvdchap";
            }
            authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/share/${pkgType}/${this.props.identifier}`, null, 'PUT')
                .then(shareResponse => {
                    shareResponse.shortUrl && shareResponse.thumbnail && this.setState({shareResponse});
                    this.shareDialog && this.shareDialog.open();
                    document.getElementById('link-to-item') && document.getElementById('link-to-item').select();
                }).catch(err => {
                console.log(err);
            });
        }
        else {
            //TODO: there is some historical reasons for this.  Need to clean it up and use "type" everywhere
            let urlEnding = "cc";
            let body = null;
            if (this.props.type == "ccs") {
                urlEnding = "ccs"
                body = this.props.identifier
            } else if (this.props.multipleAssets) {
                urlEnding = "cces";
                body = this.props.identifier
            } else{
                urlEnding = "cc/" + this.props.identifier;
            }
            authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/share/${urlEnding}`, body, 'PUT')
                .then(shareResponse => {
                    shareResponse.shortUrl && shareResponse.thumbnail && this.setState({shareResponse});
                    this.shareDialog && this.shareDialog.open();
                    document.getElementById('link-to-item') && document.getElementById('link-to-item').select();
                }).catch(err => {
                console.log(err);
            });
        }
    }

    componentWillUnmount() {
        this.shareDialog && this.shareDialog.close();
    }

    open() {
        this.shareDialog.open();
    }

    handleCopyClick() {
        const inputWithLink = document.getElementById('link-to-item');
        copyToClipboard(inputWithLink);
    }

    handleRadioClick(e) {
        if (e.target.value === 'public') {
            // this is so if a user enters a password but changes back to public visibility we remove the password and clear the password text
            this.setState({passwordText: ''});
            this.makeUpdateRequestForShare({password: '', isPrivate: false}, this.state.shareResponse.id);
        }

        return this.setState({visibility: e.target.value});
    }

    showPermissionsSettingsClick() {
        return this.setState(state => ({showPermissionsSettings: !state.showPermissionsSettings}));
    }

    passwordInputOnChange(event) {
        return this.setState({passwordText: event.target.value.trim()});
    }

    updateShareWithPassword() {
        const {passwordText, shareResponse: {id}} = this.state;
        const body = {password: passwordText, isPrivate: passwordText ? true : false};
        return this.makeUpdateRequestForShare(body, id);
    }

    makeUpdateRequestForShare(body, shareId) {
        authorizedRequest(`${process.env.REACT_APP_WEB_API_URI}/sec/v1/share/${shareId}`, body, 'PUT')
            .catch(err => {
                console.log(err);
            });
    }

    render() {
        const {identifier, photoCount, onClose, clipCount, thumbnail} = this.props;
        const {passwordText, shareResponse, showPermissionsSettings, visibility} = this.state;

        const photoVerbiage = photoCount === 1 ? 'Photo' : 'Photos';
        const videoVerbiage = clipCount === 1 ? 'Video' : 'Videos';
        const thisTheseVerbiage = photoCount === 1 || clipCount === 1 ? 'this' : 'these';
        const emailShareSubject = `${photoCount ? `${photoCount} ${photoVerbiage}` : ''}${clipCount && photoCount ? ' and ' : ''}${clipCount ? `${clipCount} ${videoVerbiage}` : ''} shared via iMemories`;
        const emailShareBody = `View ${thisTheseVerbiage} ${photoCount ? `${photoCount} ${photoVerbiage}` : ''}${clipCount && photoCount ? ' and ' : ''}${clipCount ? `${clipCount} ${videoVerbiage}` : ''} shared via iMemories: ${shareResponse.shortUrl}`

        return (
            <Dialog
                ref={el => {
                    this.shareDialog = el;
                }}
                className="share-dialog"
                canCancel={true}
                cancel={onClose}
                onClose={onClose}
            >
                <React.Fragment>
                    <div>
                        <div className="share-dialog-header">
                            <img src={thumbnail || (shareResponse && shareResponse.thumbnail)} alt="thumb"/>
                            <h1>Share</h1>
                            <div className="item-count-description">
                                <div className="photo">{photoCount} Photos</div>
                                <div className="video">{clipCount} Videos</div>
                            </div>
                            <div id="privacy-display" className={visibility === 'public' ? '' : ''}
                                 onClick={this.showPermissionsSettingsClick}>
                                {`${makeFirstLetterUppercase(visibility)}${visibility === 'public' ? '' : ', Secured'}`}
                                <div className={visibility === 'public' ? 'unlock' : 'lock'}></div>
                                <div className={this.state.showPermissionsSettings ? 'open' : 'closed'}></div>
                            </div>
                        </div>
                        <div>
                            {showPermissionsSettings &&
                            <form>
                                <p>Select your permissions for this share:</p>
                                <div className="form-radio-label">
                                    <input type="radio" id="publicRadio"
                                           name="permissions" value="public" checked={visibility === 'public'}
                                           onChange={this.handleRadioClick}/>
                                    <span className="new-radio-btn"></span>
                                    <label htmlFor="publicRadio">Public</label>
                                </div>
                                <div className="form-radio-label">
                                    <input type="radio" id="privateRadio"
                                           name="permissions" value="private" checked={visibility === 'private'}
                                           onChange={this.handleRadioClick}/>
                                    <span className="new-radio-btn"></span>
                                    <label htmlFor="privateRadio">Private</label>
                                    {visibility === 'private' &&
                                    <input
                                        autoComplete="off"
                                        id="share-password"
                                        type="password"
                                        value={passwordText}
                                        onChange={this.passwordInputOnChange}
                                        onBlur={this.updateShareWithPassword}
                                        disabled={visibility === 'public'}
                                        placeholder="Enter Password"
                                    />}
                                </div>
                            </form>
                            }
                            <div className="share-link">
                                <div className="share-link-title">Use this link to share and view your media:</div>
                                <input id="link-to-item" value={(visibility === 'private' && !passwordText) ? "": shareResponse.shortUrl || ''} readOnly={true}/>
                                <Button
                                    buttonStyle="secondary"
                                    className="imem-button-small"
                                    buttonLabel="Copy"
                                    disabled={visibility === 'private' && !passwordText}
                                    onClick={this.handleCopyClick}/>
                                <div>
                                    <div className="share-link-title">Share via email or social media:</div>
                                    <div className="social-links">
                                        <EmailShareButton
                                            url={shareResponse.shortUrl}
                                            subject={emailShareSubject}
                                            body={emailShareBody}
                                        >
                                            <span>Email</span>
                                        </EmailShareButton>
                                    </div>
                                    <div className="social-links">
                                        <div
                                            role="button"
                                            className="SocialMediaShareButton SocialMediaShareButton--facebook"
                                            onClick={() => FB.ui({
                                                method: 'share',
                                                href: shareResponse.shortUrl,
                                            }, function (response) {
                                            })}>
                                            <span>Facebook</span>
                                        </div>
                                    </div>
                                    <div className="social-links">
                                        <TwitterShareButton url={shareResponse.shortUrl} title="Shared via iMemories:">
                                            <span>Twitter</span>
                                        </TwitterShareButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            </Dialog>
        );
    }
}

ShareDialog.propTypes = {
    clipCount: PropTypes.number,
    identifier: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.array
    ]).isRequired,
    photoCount: PropTypes.number,
    onClose: PropTypes.func.isRequired,
    thumbnail: PropTypes.string,
    currentAsset: PropTypes.object,
    type: PropTypes.string,
    multipleAssets: PropTypes.bool
};


// WEBPACK FOOTER //
// ./src/common/components/share-dialog.jsx